import SockJS from 'sockjs-client';
import Notifications from './Notifications';
import Contest from './Contest';

const Connection = {
	sockjsTimeout: null,
	sockjsHeartbeatTimeout: 35000,  // heartbeat is sent every 25s, this is the limit at which we re-connect
	reconnectCount: 0,
	numberOfActiveConnections: 0,

	init: function() {

		// open SockJS
		if (Screen.options.platformUrl) {
			this.openSocket(Screen.options.screenHash, Screen.options.platformUrl);
		} else {
			log('No screen platformUrl provided!');
		}
	},

	openSocket: function(auth, url) {
		if (document.visibilityState === 'prerender') {

			// skip connection for chrome's prerendered pages
			log('SCREEN SOCKET skip connection', 'document.visibilityState', document.visibilityState);
			return;
		}
		log('SCREEN SOCKET open', url);
		const that = this;
		const sock = new SockJS(url);

		sock.onopen = function() {
			log(`SCREEN SOCKET opened ${sock.transport}, active connections: ${++that.numberOfActiveConnections}`);
			sock.send(JSON.stringify({
				data_type: 'auth',
				data: auth,
			}));
			receivedHeartbeat();
		};

		sock.onmessage = function(event) {
			receivedHeartbeat();
			let data;
			try {
				data = jQuery.parseJSON(event.data);
			} catch (err) {
				Screen.throwError(err);
			}
			log('------- SCREEN MESSAGE -------', data);
			if (data.data_type === 'notifications') {
				Notifications.addToQueue(data.notifications);
			} else if (data.data_type === 'contest_start') {
				Screen.changeMode('contest');
				Contest.start(data.contest);
			} else if (data.data_type === 'auth' && data.data.message === 'success') {
				log('SCREEN SOCKET authenticated');
				that.reconnectCount = 0;  // Successfully connected. Reset cool down time for reconnect.
			} else if (data.data_type === 'error') {
				Screen.throwError(data.data.message);
			} else if (data.data_type === 'auth_error') {
				Screen.throwError('Platform auth error');
			} else if (data.data_type === 'reload') {
				// eslint-disable-next-line no-magic-numbers
				let delay = parseInt(data.delay) * 1000;
				if (isNaN(delay)) {
					// eslint-disable-next-line no-magic-numbers
					delay = 1000;
				}
				setTimeout(function() {
					window.location.reload(true);
				}, delay);
			}
		};

		sock.onclose = function() {
			log(`SCREEN SOCKET closed, active connections: ${--that.numberOfActiveConnections}`);
			that.reconnectCount++;
			// eslint-disable-next-line no-magic-numbers
			that.reconnectCount = Math.min(that.reconnectCount, 10);
			receivedHeartbeat(Math.pow(that.reconnectCount, 2) * 100); // Wait number of 0.1*seconds^2 for reconnect
		};

		sock.onerror = function(e) {
			log('SCREEN SOCKET error', e);
			Screen.throwError('SOCKET ERROR ' + e);
		};

		// workaround for connections that go silent after a while and do not receive the 'onclose' signal
		// (until sockjs detects heartbeats on the client automatically)
		sock.onheartbeat = function() {
			receivedHeartbeat();  // this will clear the re-connect timeout
		};

		function receivedHeartbeat(timeout) {
			log('SCREEN SOCKET receivedHeartbeat');
			clearTimeout(that.sockjsTimeout);
			that.sockjsTimeout = setTimeout(function() {
				log('SCREEN SOCKET receivedHeartbeat re-open');

				// if no heartbeat was received for a while, re-open the socket
				sock.close();
				that.openSocket(auth, url);
			}, timeout ? timeout : that.sockjsHeartbeatTimeout);
		}
	},
};

export default Connection;
